import { MatchAggregated } from 'functions/src/types/firestore/Game/Tournament/Bracket';
import { MatchDrawer } from 'src/components/referee-portal/MatchDrawer';
import { useDrawer } from './useDrawer';
import { MatchProvider } from 'src/components/tournaments/match/MatchProvider';

export type MatchDrawerMatch = Pick<MatchAggregated<Date>, 'id' | 'startTime'> &
  Required<Pick<MatchAggregated<Date>, 'team1' | 'team2'>>;

export type MatchDrawerProps = {
  match: MatchDrawerMatch;
  gameId: string;
  tournamentId: string;
};

export function useMatchDrawer({
  gameId,
  tournamentId,
}: Omit<MatchDrawerProps, 'match'>) {
  const { open: openDrawer, close: closeMatchDrawer } = useDrawer(tournamentId);

  const openMatchDrawer = ({ match }: Pick<MatchDrawerProps, 'match'>) => {
    openDrawer({
      children: (
        <MatchProvider {...match} status={'inactive'}>
          <MatchDrawer
            gameId={gameId}
            tournamentId={tournamentId}
            onClose={() => {
              closeMatchDrawer();
            }}
          />
        </MatchProvider>
      ),
    });
  };

  return {
    openMatchDrawer,
    closeMatchDrawer,
  };
}
